/**
 * PageHeader — title + optional description and right-aligned actions slot.
 *
 * Used on every entity page (Models, Trajectories, Datasets) to keep visual
 * rhythm consistent.
 */

import { cn } from '@/lib/utils'

interface PageHeaderProps {
  title: string
  description?: string
  /** A status chip beside the title, e.g. the team's billing mode. */
  badge?: React.ReactNode
  actions?: React.ReactNode
  className?: string
}

export function PageHeader({
  title,
  description,
  badge,
  actions,
  className,
}: PageHeaderProps): React.JSX.Element {
  return (
    <div className={cn('flex items-start justify-between gap-4', className)}>
      <div className="min-w-0 space-y-1">
        <div className="flex flex-wrap items-center gap-3">
          <h1 className="text-2xl font-serif font-medium text-foreground">{title}</h1>
          {badge}
        </div>
        {description && (
          <p className="text-sm text-muted-foreground">{description}</p>
        )}
      </div>
      {actions && <div className="flex shrink-0 items-center gap-2">{actions}</div>}
    </div>
  )
}
